import { EOnboardingDiscoverySource, EOnboardingChosenReason } from '@constants';
import { Radio } from 'antd';
import { Trans } from 'react-i18next';

import { ItemWrapper, Wrapper } from './ReasonRadio.styles';

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  options: EOnboardingDiscoverySource[] | EOnboardingChosenReason[];
};

export const ReasonRadio = ({ value, onChange, options }: Props) => {
  return (
    <Wrapper>
      {options.map(reason => {
        const checked = value?.includes(reason) ?? false;
        return (
          <ItemWrapper key={reason} onClick={() => onChange?.(reason)} $isSelected={checked}>
            <Radio checked={checked} onClick={e => e.preventDefault()}></Radio>
            <span>
              <Trans
                i18nKey={`StudentOnboardingPageTranslations:${reason}`}
                components={{
                  strong: <strong />
                }}
              />
            </span>
          </ItemWrapper>
        );
      })}
    </Wrapper>
  );
};
